<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                facilityForm: () => import('../forms/FacilityForm'),
                harvestingForm: () => import('../forms/HarvestingForm'),
                fileForm: () => import('../forms/FileForm'),
                staffMemberForm: () => import('../forms/StaffMemberForm'),
                fields: [
                    { type: 'autocomplete', text: 'Facility', value: 'facilityId', rules: [v => !!v || 'Facility is required'], isRequired: true, form: () => import('./FacilityForm'), apiMethod: 'Facilities', claim: 'Facilities' },
                    { type: 'datetime', text: 'Cleaned On', value: 'cleanedOn', rules: [v => !!v || 'Cleaned On is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Staff Member', value: 'staffMemberId', rules: [v => !!v || 'Staff Member is required'], isRequired: true, form: () => import('./StaffMemberForm'), apiMethod: 'StaffMembers', claim: 'StaffMembers' },
                    { type: 'autocomplete', text: 'Harvesting', value: 'harvestingId', rules: [], form: () => import('./HarvestingForm'), apiMethod: 'Harvestings', claim: 'Harvestings' },
                    { type: 'file', text: 'Report File', value: 'reportFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                ],
                apiMethod: 'Cleanings',
                formTitle: 'Cleaning',
            }
        },
    };
</script>
